import React from 'react';
import PropTypes from 'prop-types';
import cn from "classnames";
import store from '../../../store';

const ModalHeader = ({ isTab, stationName, tileHeader, seatNumber, isTipWarning = false, customHeight, headerClassName, }) => {
  const { paymentLandscapeOrientation } = store?.getState()?.payment;
  
  return (
    <div className={cn(paymentLandscapeOrientation?  '':'h-4', "py-1 w-100 d-flex align-items-center px-2 fw-600 fs-20 color-black", isTipWarning ? "" : "modal_headers_background_color")} style={customHeight ? { height: customHeight } : undefined}>
      {stationName && (
        <div className="px-0 fs_16 col-3 text-left">
          <span>{isTab ? 'Tab' : 'Table'} : </span>
          <span>
            {stationName?.length > 8
              ? `${stationName?.substring(0, 8)}...`
              : stationName}
          </span>
        </div>
      )}
      <div className={cn(`px-0 fs_18 text-center ${!stationName && !seatNumber ? 'col-12' : stationName && seatNumber ? 'col-6' : 'col-9'}`, headerClassName)}>
        {tileHeader}
      </div>
      {seatNumber && (
        <div className="col-3 px-0 fs_16 text-right">#{seatNumber}</div>
      )}
    </div>
  );
};

ModalHeader.propTypes = {
  isTab: PropTypes.bool.isRequired,
  stationName: PropTypes.string.isRequired,
  tileHeader: PropTypes.string.isRequired,
  seatNumber: PropTypes.number.isRequired,
};

export default ModalHeader;
